import Styled from 'styled-components';

export const Container = Styled.div`
	cursor: pointer;
	box-sizing: border-box;
	position: relative;
	font-size: 12px;
	background-color: ${props => (props.disabled ? '#f3f3f3' : '#fff')};
	font-family: ${({theme}) => theme.fontFamily};
	border-width: 1px;
	border-style: solid;
	border-color: ${props => {
		if (props.expanded) {
			return '#6e0fea';
		}
		if (props.disabled) {
			return '#e6e6e6';
		} else {
			return '#e6e6e6';
		}
	}};
	height: ${props => (props.size === 'large' ? '40px' : '30px')};
	width: 100%;
	border-radius: ${props => (props.expanded ? (props.above ? '0 0 4px 4px' : '4px 4px 0px 0px') : '4px')};
	&:hover {
		border-color: ${props => !props.expanded && !props.disabled && '#a1a1a1'};
	}
`;

export const DropdownButton = Styled.div`
	box-sizing: border-box;
	display: flex;
	width: 100%;
	height: 100%;
	align-items: center;
	padding-left: 8px;
`;
export const Input = Styled.input`
	min-width: 0; /* firefox fix for flex items */
	cursor: ${props => (props.expanded ? 'text' : 'pointer')};
	color: ${props => (props.disabled ? 'rgba(p0,0,0,0.87)' : '#535353')};
	width: 100%;
	background-color: transparent;
	border: none;
	height: 100%;
	font-size: 12px;
	outline: none;
	flex: 1;
	padding: 0;
	::placeholder {
		font-size: 12px;
		color: ${props => (props.emphasizePlaceholder && !props.disabled ? '#535353' : '#a1a1a1')};
		opacity: 1;
	}
`;

export const IconContainer = Styled.div`
	display: flex;
	align-items: center;
	height: 100%;
	padding: 0px 8px 0 8px;
`;

export const InfoBadgeContainer = Styled.div`
	border: 1px solid #8E8F9F;
	border-radius: 10px;
	font-size: 10px;
	padding: 2px 8px;
`;

export const AllAction = Styled.div`
	flex-grow: 1;
	text-align: right;
	p {
		color: #535353;
		font-size: 12px;

		padding: 0;
		margin: 0 14px 0 0;
	}
`;

export const DropdownContainer = Styled.div`
	overflow: hidden;
	z-index: 1000;
	position: absolute;
	left: ${props => {
		if (props.dropdownAlignment === 'left') return '-1px';
		if (props.dropdownAlignment === 'center') return '50%';
		if (props.dropdownAlignment === 'none') return '-1px;';
	}};
	margin-left: ${props => props.dropdownAlignment === 'center' && `-${props.width / 2}px`};
	right: ${props => {
		if (props.dropdownAlignment === 'none') return '-1px;';
		if (props.dropdownAlignment === 'right') return '-1px';
	}};
	
	border: 1px solid #6e0fea;
	
	border-top-left-radius: ${({dropdownAlignment, positionAbove}) => {
		if (positionAbove) {
			return '4px';
		}
		switch (dropdownAlignment) {
			case 'center':
				return '4px';
			case 'right':
				return '4px';
			default:
				return '0';
		}
	}};
	border-top-right-radius: ${({dropdownAlignment, positionAbove}) => {
		if (positionAbove) {
			return '4px';
		}
		switch (dropdownAlignment) {
			case 'left':
				return '4px';
			case 'center':
				return '4px';
			default:
				return '0';
		}
	}};
	border-bottom-right-radius: ${({dropdownAlignment, positionAbove}) => {
		if (!positionAbove) {
			return '4px';
		}
		switch (dropdownAlignment) {
			case 'left':
				return '4px';
			case 'center':
				return '4px';
			default:
				return '0';
		}
	}};
	border-bottom-left-radius:  ${({dropdownAlignment, positionAbove}) => {
		if (!positionAbove) {
			return '4px';
		}
		switch (dropdownAlignment) {
			case 'right':
				return '4px';
			case 'center':
				return '4px';
			default:
				return '0';
		}
	}};

	box-sizing: border-box;
	background-color: #fff;
	max-height: ${props => `${props.maxHeight}px`};
	width: ${props => props.width && `${props.width}px`};
	}};
`;

export const GroupContainer = Styled.div`
	box-sizing: border-box;
	width: 100%;
	background-color: transparent;
`;

export const DropdownElement = Styled.div`
	cursor: pointer;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	z-index: 1000;
	width: 100%;
	padding: 0 ${({noPadding}) => (noPadding ? '0' : '12px')};
	overflow: hidden;
	text-overflow: ellipsis;
	background-color: ${({showFocus}) => (showFocus ? '#f0e7fc' : null)};
	&:hover {
		background-color: #f0e7fc;
	}
`;

export const Element = Styled.div`
	flex-grow: 1;
	height: 100%;
	width: calc(100% - 16px);
`;

export const RemoveElement = Styled.div`
	cursor: pointer;
	padding-left: 4px;
`;
export const GroupHeading = Styled.div`
	box-sizing: border-box;
	padding: 8px 12px;
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-bottom: 1px solid #e6e6e6;
	cursor: pointer;
`;

export const GroupHeadingTextContainer = Styled.div`
	color: #535353;
	p {
		font-size: 12px;
		padding: 0;
		margin: 0;
		display: inline;
		text-transform: capitalize;

	}
`;

export const DropdownButtonPlaceholder = Styled.div`
	min-width: 0px;
	width: 100%;
`;

export const DropdownLabel = Styled.div`
	height: 11px;
	font-size: 9px;
	font-weight: 500;
	line-height: 1.22;
	letter-spacing: 1px;
	color: ${props => props.theme.colors.mediumLightGray};
	text-transform: uppercase;
	margin-bottom: 5px;
	white-space: nowrap;
	.required-extension {
		color: ${props => props.theme.colors.negativeValue};
	}
`;
